require('./openYoungDashboardProductItem.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { formatAmountObject } = require('utilities/currencyHelper');

//@commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

//@core
const { getLanguage } = require('core/i18n').i18n;

const OpenYoungDashboardProductItem = (props) => {
    const {
        amount,
        currency,
        title,
        titleSmall
    } = props;

    const amountObject = {
        amount: Math.abs(amount),
        currency
    };
    return (
        <div className="open-young-dashboard-product-item">
            <div className="row">
                <div className="open-young-dashboard-product-item__content-title col-xs-12 col-sm-7">
                    <span className="open-young-dashboard-product-item__title">{title}</span>
                    <span className="open-young-dashboard-product-item__title--small">{titleSmall}</span>
                </div>
                <div className="col-xs-12 col-sm-5">
                    <div className="open-young-dashboard-product-item__amount-object">
                        <div className="open-young-dashboard-product-item__col">
                            <span className="open-young-dashboard-product-item__amount">
                                <OneLineSymbolAmount
                                    amountObject={amountObject}
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(amountObject, true)}
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

OpenYoungDashboardProductItem.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleSmall: PropTypes.string.isRequired,
};

module.exports = OpenYoungDashboardProductItem;
